/**
 * Route for `coupon-code-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CouponCodeWidgetPage } from "../features/coupon-code-widget/CouponCodeWidgetPage";

export const couponCodeWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/coupon-code-widget",
	component: CouponCodeWidgetPage,
});

export default couponCodeWidgetRoute;
